/* tslint:disable */
/* eslint-disable */
/**
 * Ingka DAM uploader
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdminUserDto
 */
export interface AdminUserDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AssetDto
 */
export interface AssetDto {
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'uniqueId': string;
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'filename': string;
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'filesize': number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'extension': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'state': AssetDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'originalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'copyright'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'negotiatedUsageRights'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'producedBy'?: AssetDtoProducedByEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'producerId': number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'productionOrderedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'releaseDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'endOfNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetDto
     */
    'confirmEndOfNegotiatedUsageRights'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'deliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'userDeliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'subDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'userSubDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'intendedTiming'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'objective'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'channel'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'contentType'?: AssetDtoContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'assetType'?: AssetDtoAssetTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'fiscalYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'launch'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'otherNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'disclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'userDisclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'versionReason'?: AssetDtoVersionReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'updatedAt': string;
}

export const AssetDtoStateEnum = {
    InProgress: 'IN_PROGRESS',
    Viewed: 'VIEWED',
    Done: 'DONE',
    Denied: 'DENIED'
} as const;

export type AssetDtoStateEnum = typeof AssetDtoStateEnum[keyof typeof AssetDtoStateEnum];
export const AssetDtoProducedByEnum = {
    Ingka: 'INGKA',
    Agency: 'AGENCY',
    InternalLocalProduction: 'INTERNAL_LOCAL_PRODUCTION'
} as const;

export type AssetDtoProducedByEnum = typeof AssetDtoProducedByEnum[keyof typeof AssetDtoProducedByEnum];
export const AssetDtoContentTypeEnum = {
    Image: 'IMAGE',
    IndesignPackages: 'INDESIGN_PACKAGES',
    Video: 'VIDEO',
    MusicSound: 'MUSIC_SOUND',
    Copy: 'COPY',
    Subtitle: 'SUBTITLE',
    Transcript: 'TRANSCRIPT',
    Caption: 'CAPTION',
    Billboard: 'BILLBOARD',
    BrochureBooklet: 'BROCHURE_BOOKLET',
    BuyingGuide: 'BUYING_GUIDE',
    ContentDeliveryPackage: 'CONTENT_DELIVERY_PACKAGE',
    CopyText: 'COPY_TEXT',
    EventInformation: 'EVENT_INFORMATION',
    Guidelines: 'GUIDELINES',
    Layout: 'LAYOUT',
    Offer: 'OFFER',
    Overview: 'OVERVIEW',
    Poster: 'POSTER',
    PreDelivery: 'PRE_DELIVERY',
    Presentation: 'PRESENTATION',
    Preview: 'PREVIEW',
    Recipe: 'RECIPE',
    Sign: 'SIGN',
    Tabletalker: 'TABLETALKER',
    TermsAndConditions: 'TERMS_AND_CONDITIONS',
    InStoreMap: 'IN_STORE_MAP'
} as const;

export type AssetDtoContentTypeEnum = typeof AssetDtoContentTypeEnum[keyof typeof AssetDtoContentTypeEnum];
export const AssetDtoAssetTypeEnum = {
    Audio: 'AUDIO',
    Document: 'DOCUMENT',
    Image: 'IMAGE',
    MotionMedia: 'MOTION_MEDIA',
    WorkingFiles: 'WORKING_FILES'
} as const;

export type AssetDtoAssetTypeEnum = typeof AssetDtoAssetTypeEnum[keyof typeof AssetDtoAssetTypeEnum];
export const AssetDtoVersionReasonEnum = {
    NewFile: 'NEW_FILE',
    SubmittedForReview: 'SUBMITTED_FOR_REVIEW'
} as const;

export type AssetDtoVersionReasonEnum = typeof AssetDtoVersionReasonEnum[keyof typeof AssetDtoVersionReasonEnum];

/**
 * 
 * @export
 * @interface AssetWithRelatedMetadataDto
 */
export interface AssetWithRelatedMetadataDto {
    /**
     * 
     * @type {number}
     * @memberof AssetWithRelatedMetadataDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'uniqueId': string;
    /**
     * 
     * @type {number}
     * @memberof AssetWithRelatedMetadataDto
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'filename': string;
    /**
     * 
     * @type {number}
     * @memberof AssetWithRelatedMetadataDto
     */
    'filesize': number;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'extension': string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'state': AssetWithRelatedMetadataDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'originalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'copyright'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetWithRelatedMetadataDto
     */
    'negotiatedUsageRights'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'producedBy'?: AssetWithRelatedMetadataDtoProducedByEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetWithRelatedMetadataDto
     */
    'producerId': number;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'productionOrderedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'releaseDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'endOfNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetWithRelatedMetadataDto
     */
    'confirmEndOfNegotiatedUsageRights'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'deliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'userDeliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'subDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'userSubDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'intendedTiming'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'objective'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetWithRelatedMetadataDto
     */
    'channel'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'contentType'?: AssetWithRelatedMetadataDtoContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'assetType'?: AssetWithRelatedMetadataDtoAssetTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetWithRelatedMetadataDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'fiscalYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'launch'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'otherNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'disclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'userDisclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'versionReason'?: AssetWithRelatedMetadataDtoVersionReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AssetWithRelatedMetadataDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {RelatedAssetMetadataDto}
     * @memberof AssetWithRelatedMetadataDto
     */
    'relatedAssetMetadata'?: RelatedAssetMetadataDto;
    /**
     * 
     * @type {DocumentMetadataDto}
     * @memberof AssetWithRelatedMetadataDto
     */
    'documentMetadata'?: DocumentMetadataDto;
}

export const AssetWithRelatedMetadataDtoStateEnum = {
    InProgress: 'IN_PROGRESS',
    Viewed: 'VIEWED',
    Done: 'DONE',
    Denied: 'DENIED'
} as const;

export type AssetWithRelatedMetadataDtoStateEnum = typeof AssetWithRelatedMetadataDtoStateEnum[keyof typeof AssetWithRelatedMetadataDtoStateEnum];
export const AssetWithRelatedMetadataDtoProducedByEnum = {
    Ingka: 'INGKA',
    Agency: 'AGENCY',
    InternalLocalProduction: 'INTERNAL_LOCAL_PRODUCTION'
} as const;

export type AssetWithRelatedMetadataDtoProducedByEnum = typeof AssetWithRelatedMetadataDtoProducedByEnum[keyof typeof AssetWithRelatedMetadataDtoProducedByEnum];
export const AssetWithRelatedMetadataDtoContentTypeEnum = {
    Image: 'IMAGE',
    IndesignPackages: 'INDESIGN_PACKAGES',
    Video: 'VIDEO',
    MusicSound: 'MUSIC_SOUND',
    Copy: 'COPY',
    Subtitle: 'SUBTITLE',
    Transcript: 'TRANSCRIPT',
    Caption: 'CAPTION',
    Billboard: 'BILLBOARD',
    BrochureBooklet: 'BROCHURE_BOOKLET',
    BuyingGuide: 'BUYING_GUIDE',
    ContentDeliveryPackage: 'CONTENT_DELIVERY_PACKAGE',
    CopyText: 'COPY_TEXT',
    EventInformation: 'EVENT_INFORMATION',
    Guidelines: 'GUIDELINES',
    Layout: 'LAYOUT',
    Offer: 'OFFER',
    Overview: 'OVERVIEW',
    Poster: 'POSTER',
    PreDelivery: 'PRE_DELIVERY',
    Presentation: 'PRESENTATION',
    Preview: 'PREVIEW',
    Recipe: 'RECIPE',
    Sign: 'SIGN',
    Tabletalker: 'TABLETALKER',
    TermsAndConditions: 'TERMS_AND_CONDITIONS',
    InStoreMap: 'IN_STORE_MAP'
} as const;

export type AssetWithRelatedMetadataDtoContentTypeEnum = typeof AssetWithRelatedMetadataDtoContentTypeEnum[keyof typeof AssetWithRelatedMetadataDtoContentTypeEnum];
export const AssetWithRelatedMetadataDtoAssetTypeEnum = {
    Audio: 'AUDIO',
    Document: 'DOCUMENT',
    Image: 'IMAGE',
    MotionMedia: 'MOTION_MEDIA',
    WorkingFiles: 'WORKING_FILES'
} as const;

export type AssetWithRelatedMetadataDtoAssetTypeEnum = typeof AssetWithRelatedMetadataDtoAssetTypeEnum[keyof typeof AssetWithRelatedMetadataDtoAssetTypeEnum];
export const AssetWithRelatedMetadataDtoVersionReasonEnum = {
    NewFile: 'NEW_FILE',
    SubmittedForReview: 'SUBMITTED_FOR_REVIEW'
} as const;

export type AssetWithRelatedMetadataDtoVersionReasonEnum = typeof AssetWithRelatedMetadataDtoVersionReasonEnum[keyof typeof AssetWithRelatedMetadataDtoVersionReasonEnum];

/**
 * 
 * @export
 * @interface AssetsControllerCreateRequest
 */
export interface AssetsControllerCreateRequest {
    /**
     * 
     * @type {Array<AssetsControllerCreateRequestFilesInner>}
     * @memberof AssetsControllerCreateRequest
     */
    'files': Array<AssetsControllerCreateRequestFilesInner>;
}
/**
 * 
 * @export
 * @interface AssetsControllerCreateRequestFilesInner
 */
export interface AssetsControllerCreateRequestFilesInner {
    /**
     * 
     * @type {number}
     * @memberof AssetsControllerCreateRequestFilesInner
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerCreateRequestFilesInner
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerCreateRequestFilesInner
     */
    'fileUniqueId': string;
    /**
     * 
     * @type {number}
     * @memberof AssetsControllerCreateRequestFilesInner
     */
    'filesize': number;
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerCreateRequestFilesInner
     */
    'fileExtension': string;
}
/**
 * 
 * @export
 * @interface AssetsControllerGenerateUploadUrlsRequest
 */
export interface AssetsControllerGenerateUploadUrlsRequest {
    /**
     * 
     * @type {Array<AssetsControllerGenerateUploadUrlsRequestFilesInner>}
     * @memberof AssetsControllerGenerateUploadUrlsRequest
     */
    'files': Array<AssetsControllerGenerateUploadUrlsRequestFilesInner>;
}
/**
 * 
 * @export
 * @interface AssetsControllerGenerateUploadUrlsRequestFilesInner
 */
export interface AssetsControllerGenerateUploadUrlsRequestFilesInner {
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerGenerateUploadUrlsRequestFilesInner
     */
    'clientFileId': string;
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerGenerateUploadUrlsRequestFilesInner
     */
    'filename': string;
    /**
     * 
     * @type {number}
     * @memberof AssetsControllerGenerateUploadUrlsRequestFilesInner
     */
    'filesize': number;
    /**
     * 
     * @type {string}
     * @memberof AssetsControllerGenerateUploadUrlsRequestFilesInner
     */
    'contentType': string;
}
/**
 * 
 * @export
 * @interface AuthorizationErrorResponseDto
 */
export interface AuthorizationErrorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationErrorResponseDto
     */
    'code': AuthorizationErrorResponseDtoCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof AuthorizationErrorResponseDto
     */
    'uploadId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationErrorResponseDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationErrorResponseDto
     */
    'body': string;
}

export const AuthorizationErrorResponseDtoCodeEnum = {
    NotOwner: 'NOT_OWNER',
    WrongFranchise: 'WRONG_FRANCHISE',
    AdminRequired: 'ADMIN_REQUIRED',
    CommentsForbidden: 'COMMENTS_FORBIDDEN',
    UploadFinalized: 'UPLOAD_FINALIZED'
} as const;

export type AuthorizationErrorResponseDtoCodeEnum = typeof AuthorizationErrorResponseDtoCodeEnum[keyof typeof AuthorizationErrorResponseDtoCodeEnum];

/**
 * 
 * @export
 * @interface BynderMetadataDto
 */
export interface BynderMetadataDto {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'End date of negotiated usage rights': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Copyright': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Sub delivery': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Objective': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Markets': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Owner': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Produced By': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Release date': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Channel': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Disclaimer': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Language': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Campaigns / Deliveries': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Fiscal year': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BynderMetadataDto
     */
    'Negotiated usage rights': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CreateCommentDto
 */
export interface CreateCommentDto {
    /**
     * 
     * @type {number}
     * @memberof CreateCommentDto
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CreateFeedbackDto
 */
export interface CreateFeedbackDto {
    /**
     * 
     * @type {number}
     * @memberof CreateFeedbackDto
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFeedbackDto
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFeedbackDto
     */
    'uploadId'?: number;
}
/**
 * 
 * @export
 * @interface CreatePreferenceDto
 */
export interface CreatePreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePreferenceDto
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePreferenceDto
     */
    'belongsToMarket'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePreferenceDto
     */
    'caresAboutMarket'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePreferenceDto
     */
    'notificationForMarket'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CreateUploadDto
 */
export interface CreateUploadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUploadDto
     */
    'type': CreateUploadDtoTypeEnum;
}

export const CreateUploadDtoTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Document: 'DOCUMENT',
    Delivery: 'DELIVERY'
} as const;

export type CreateUploadDtoTypeEnum = typeof CreateUploadDtoTypeEnum[keyof typeof CreateUploadDtoTypeEnum];

/**
 * 
 * @export
 * @interface DocumentMetadataDto
 */
export interface DocumentMetadataDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentMetadataDto
     */
    'assetId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentMetadataDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentMetadataDto
     */
    'isCompliant'?: boolean;
}
/**
 * 
 * @export
 * @interface GetCommentDto
 */
export interface GetCommentDto {
    /**
     * 
     * @type {number}
     * @memberof GetCommentDto
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommentDto
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCommentDto
     */
    'seen': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCommentDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCommentDto
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof GetCommentDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetCommentDto
     */
    'userName': string;
}
/**
 * 
 * @export
 * @interface MarketProducerDto
 */
export interface MarketProducerDto {
    /**
     * 
     * @type {number}
     * @memberof MarketProducerDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MarketProducerDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MetadataResponseDto
 */
export interface MetadataResponseDto {
    /**
     * 
     * @type {BynderMetadataDto}
     * @memberof MetadataResponseDto
     */
    'bynder': BynderMetadataDto;
    /**
     * 
     * @type {Array<ProducerDto>}
     * @memberof MetadataResponseDto
     */
    'producers': Array<ProducerDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetadataResponseDto
     */
    'channels': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MetadataResponseDto
     */
    'launch': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MetadataResponseDto
     */
    'producedBy': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MetadataResponseDto
     */
    'documentContentTypes': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'performerId': string;
    /**
     * 
     * @type {NotificationUploadDto}
     * @memberof NotificationDto
     */
    'upload': NotificationUploadDto;
    /**
     * 
     * @type {number}
     * @memberof NotificationDto
     */
    'uploadId': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'type': NotificationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'seenAt': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    'createdAt': string;
}

export const NotificationDtoTypeEnum = {
    Comment: 'COMMENT',
    Status: 'STATUS',
    Assign: 'ASSIGN',
    NewUpload: 'NEW_UPLOAD'
} as const;

export type NotificationDtoTypeEnum = typeof NotificationDtoTypeEnum[keyof typeof NotificationDtoTypeEnum];

/**
 * 
 * @export
 * @interface NotificationResponseDto
 */
export interface NotificationResponseDto {
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof NotificationResponseDto
     */
    'notifications': Array<NotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof NotificationResponseDto
     */
    'unseenCount': number;
}
/**
 * 
 * @export
 * @interface NotificationUploadDto
 */
export interface NotificationUploadDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationUploadDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationUploadDto
     */
    'state': NotificationUploadDtoStateEnum;
}

export const NotificationUploadDtoStateEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AdminFeedback: 'ADMIN_FEEDBACK',
    UserResponse: 'USER_RESPONSE',
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type NotificationUploadDtoStateEnum = typeof NotificationUploadDtoStateEnum[keyof typeof NotificationUploadDtoStateEnum];

/**
 * 
 * @export
 * @interface PreferenceDto
 */
export interface PreferenceDto {
    /**
     * 
     * @type {string}
     * @memberof PreferenceDto
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof PreferenceDto
     */
    'belongsToMarket': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PreferenceDto
     */
    'caresAboutMarket': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PreferenceDto
     */
    'notificationForMarket': Array<number>;
}
/**
 * 
 * @export
 * @interface ProducerDto
 */
export interface ProducerDto {
    /**
     * 
     * @type {number}
     * @memberof ProducerDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ProducerDto
     */
    'prefix': string;
    /**
     * 
     * @type {string}
     * @memberof ProducerDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProducerDto
     */
    'type': ProducerDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProducerDto
     */
    'franchise'?: string | null;
}

export const ProducerDtoTypeEnum = {
    Agency: 'AGENCY',
    Team: 'TEAM',
    Market: 'MARKET'
} as const;

export type ProducerDtoTypeEnum = typeof ProducerDtoTypeEnum[keyof typeof ProducerDtoTypeEnum];

/**
 * 
 * @export
 * @interface RelatedAssetDto
 */
export interface RelatedAssetDto {
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetDto
     */
    'type': RelatedAssetDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetDto
     */
    'extension': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetDto
     */
    'locale': string;
    /**
     * 
     * @type {number}
     * @memberof RelatedAssetDto
     */
    'relatedAssetMetadataId': number;
}

export const RelatedAssetDtoTypeEnum = {
    Subtitle: 'SUBTITLE',
    Transcript: 'TRANSCRIPT',
    Caption: 'CAPTION'
} as const;

export type RelatedAssetDtoTypeEnum = typeof RelatedAssetDtoTypeEnum[keyof typeof RelatedAssetDtoTypeEnum];

/**
 * 
 * @export
 * @interface RelatedAssetMetadataDto
 */
export interface RelatedAssetMetadataDto {
    /**
     * 
     * @type {number}
     * @memberof RelatedAssetMetadataDto
     */
    'assetId': number;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedAssetMetadataDto
     */
    'isOnlySocialMedia': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedAssetMetadataDto
     */
    'isVideoWithAudio': boolean;
    /**
     * 
     * @type {string}
     * @memberof RelatedAssetMetadataDto
     */
    'accessibilityPurpose': RelatedAssetMetadataDtoAccessibilityPurposeEnum;
    /**
     * 
     * @type {Array<RelatedAssetDto>}
     * @memberof RelatedAssetMetadataDto
     */
    'relatedAssets': Array<RelatedAssetDto>;
}

export const RelatedAssetMetadataDtoAccessibilityPurposeEnum = {
    Informative: 'INFORMATIVE',
    Decorative: 'DECORATIVE'
} as const;

export type RelatedAssetMetadataDtoAccessibilityPurposeEnum = typeof RelatedAssetMetadataDtoAccessibilityPurposeEnum[keyof typeof RelatedAssetMetadataDtoAccessibilityPurposeEnum];

/**
 * 
 * @export
 * @interface SimilaritySearchAssetDto
 */
export interface SimilaritySearchAssetDto {
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchAssetDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchAssetDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchAssetDto
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof SimilaritySearchAssetDto
     */
    'score': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilaritySearchAssetDto
     */
    'usageRights': Array<string>;
}
/**
 * 
 * @export
 * @interface SimilaritySearchResponseDto
 */
export interface SimilaritySearchResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchResponseDto
     */
    'filename': string;
    /**
     * 
     * @type {Array<SimilaritySearchAssetDto>}
     * @memberof SimilaritySearchResponseDto
     */
    'result': Array<SimilaritySearchAssetDto>;
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchResponseDto
     */
    'status': SimilaritySearchResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SimilaritySearchResponseDto
     */
    'message'?: string;
}

export const SimilaritySearchResponseDtoStatusEnum = {
    Success: 'success',
    Timeout: 'timeout',
    Error: 'error'
} as const;

export type SimilaritySearchResponseDtoStatusEnum = typeof SimilaritySearchResponseDtoStatusEnum[keyof typeof SimilaritySearchResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface StartFileuploadResult
 */
export interface StartFileuploadResult {
    /**
     * 
     * @type {string}
     * @memberof StartFileuploadResult
     */
    'clientFileId': string;
    /**
     * 
     * @type {string}
     * @memberof StartFileuploadResult
     */
    'filename': string;
    /**
     * 
     * @type {number}
     * @memberof StartFileuploadResult
     */
    'filesize': number;
    /**
     * 
     * @type {string}
     * @memberof StartFileuploadResult
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof StartFileuploadResult
     */
    'fileUniqueId': string;
    /**
     * 
     * @type {string}
     * @memberof StartFileuploadResult
     */
    'uploadUrl': string;
}
/**
 * 
 * @export
 * @interface UpdateAssetDto
 */
export interface UpdateAssetDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateAssetDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'uniqueId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAssetDto
     */
    'uploadId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'fileId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'filename'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAssetDto
     */
    'filesize'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'extension'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'state'?: UpdateAssetDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'originalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'copyright'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAssetDto
     */
    'negotiatedUsageRights'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'producedBy'?: UpdateAssetDtoProducedByEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateAssetDto
     */
    'producerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'productionOrderedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'releaseDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'endOfNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAssetDto
     */
    'confirmEndOfNegotiatedUsageRights'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'deliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'userDeliveryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'subDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'userSubDelivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'intendedTiming'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'objective'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAssetDto
     */
    'channel'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'contentType'?: UpdateAssetDtoContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'assetType'?: UpdateAssetDtoAssetTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAssetDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'fiscalYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'launch'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'otherNegotiatedUsageRights'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'disclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'userDisclaimer'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'versionReason'?: UpdateAssetDtoVersionReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetDto
     */
    'updatedAt'?: string;
}

export const UpdateAssetDtoStateEnum = {
    InProgress: 'IN_PROGRESS',
    Viewed: 'VIEWED',
    Done: 'DONE',
    Denied: 'DENIED'
} as const;

export type UpdateAssetDtoStateEnum = typeof UpdateAssetDtoStateEnum[keyof typeof UpdateAssetDtoStateEnum];
export const UpdateAssetDtoProducedByEnum = {
    Ingka: 'INGKA',
    Agency: 'AGENCY',
    InternalLocalProduction: 'INTERNAL_LOCAL_PRODUCTION'
} as const;

export type UpdateAssetDtoProducedByEnum = typeof UpdateAssetDtoProducedByEnum[keyof typeof UpdateAssetDtoProducedByEnum];
export const UpdateAssetDtoContentTypeEnum = {
    Image: 'IMAGE',
    IndesignPackages: 'INDESIGN_PACKAGES',
    Video: 'VIDEO',
    MusicSound: 'MUSIC_SOUND',
    Copy: 'COPY',
    Subtitle: 'SUBTITLE',
    Transcript: 'TRANSCRIPT',
    Caption: 'CAPTION',
    Billboard: 'BILLBOARD',
    BrochureBooklet: 'BROCHURE_BOOKLET',
    BuyingGuide: 'BUYING_GUIDE',
    ContentDeliveryPackage: 'CONTENT_DELIVERY_PACKAGE',
    CopyText: 'COPY_TEXT',
    EventInformation: 'EVENT_INFORMATION',
    Guidelines: 'GUIDELINES',
    Layout: 'LAYOUT',
    Offer: 'OFFER',
    Overview: 'OVERVIEW',
    Poster: 'POSTER',
    PreDelivery: 'PRE_DELIVERY',
    Presentation: 'PRESENTATION',
    Preview: 'PREVIEW',
    Recipe: 'RECIPE',
    Sign: 'SIGN',
    Tabletalker: 'TABLETALKER',
    TermsAndConditions: 'TERMS_AND_CONDITIONS',
    InStoreMap: 'IN_STORE_MAP'
} as const;

export type UpdateAssetDtoContentTypeEnum = typeof UpdateAssetDtoContentTypeEnum[keyof typeof UpdateAssetDtoContentTypeEnum];
export const UpdateAssetDtoAssetTypeEnum = {
    Audio: 'AUDIO',
    Document: 'DOCUMENT',
    Image: 'IMAGE',
    MotionMedia: 'MOTION_MEDIA',
    WorkingFiles: 'WORKING_FILES'
} as const;

export type UpdateAssetDtoAssetTypeEnum = typeof UpdateAssetDtoAssetTypeEnum[keyof typeof UpdateAssetDtoAssetTypeEnum];
export const UpdateAssetDtoVersionReasonEnum = {
    NewFile: 'NEW_FILE',
    SubmittedForReview: 'SUBMITTED_FOR_REVIEW'
} as const;

export type UpdateAssetDtoVersionReasonEnum = typeof UpdateAssetDtoVersionReasonEnum[keyof typeof UpdateAssetDtoVersionReasonEnum];

/**
 * 
 * @export
 * @interface UpdateDocumentMetadataDto
 */
export interface UpdateDocumentMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentMetadataDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDocumentMetadataDto
     */
    'isCompliant'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateRelatedAssetMetadataDto
 */
export interface UpdateRelatedAssetMetadataDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateRelatedAssetMetadataDto
     */
    'assetId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRelatedAssetMetadataDto
     */
    'isOnlySocialMedia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRelatedAssetMetadataDto
     */
    'isVideoWithAudio'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRelatedAssetMetadataDto
     */
    'accessibilityPurpose'?: UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum;
}

export const UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum = {
    Informative: 'INFORMATIVE',
    Decorative: 'DECORATIVE'
} as const;

export type UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum = typeof UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum[keyof typeof UpdateRelatedAssetMetadataDtoAccessibilityPurposeEnum];

/**
 * 
 * @export
 * @interface UpdateUploadDto
 */
export interface UpdateUploadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUploadDto
     */
    'state'?: UpdateUploadDtoStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUploadDto
     */
    'allOriginalConfirmation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUploadDto
     */
    'assigneeId'?: string;
}

export const UpdateUploadDtoStateEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AdminFeedback: 'ADMIN_FEEDBACK',
    UserResponse: 'USER_RESPONSE',
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type UpdateUploadDtoStateEnum = typeof UpdateUploadDtoStateEnum[keyof typeof UpdateUploadDtoStateEnum];

/**
 * 
 * @export
 * @interface UploadDto
 */
export interface UploadDto {
    /**
     * 
     * @type {number}
     * @memberof UploadDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UploadDto
     */
    'type': UploadDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadDto
     */
    'allOriginalConfirmation': boolean | null;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadDto
     */
    'user': UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadDto
     */
    'assignee'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof UploadDto
     */
    'state': UploadDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadDto
     */
    'updatedAt': string;
}

export const UploadDtoTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Document: 'DOCUMENT',
    Delivery: 'DELIVERY'
} as const;

export type UploadDtoTypeEnum = typeof UploadDtoTypeEnum[keyof typeof UploadDtoTypeEnum];
export const UploadDtoStateEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AdminFeedback: 'ADMIN_FEEDBACK',
    UserResponse: 'USER_RESPONSE',
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type UploadDtoStateEnum = typeof UploadDtoStateEnum[keyof typeof UploadDtoStateEnum];

/**
 * 
 * @export
 * @interface UploadStateRulesDto
 */
export interface UploadStateRulesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadStateRulesDto
     */
    'finalizedStates': Array<UploadStateRulesDtoFinalizedStatesEnum>;
}

export const UploadStateRulesDtoFinalizedStatesEnum = {
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type UploadStateRulesDtoFinalizedStatesEnum = typeof UploadStateRulesDtoFinalizedStatesEnum[keyof typeof UploadStateRulesDtoFinalizedStatesEnum];

/**
 * 
 * @export
 * @interface UploadWithAssetsDto
 */
export interface UploadWithAssetsDto {
    /**
     * 
     * @type {number}
     * @memberof UploadWithAssetsDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UploadWithAssetsDto
     */
    'type': UploadWithAssetsDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadWithAssetsDto
     */
    'allOriginalConfirmation': boolean | null;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadWithAssetsDto
     */
    'user': UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadWithAssetsDto
     */
    'assignee'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof UploadWithAssetsDto
     */
    'state': UploadWithAssetsDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadWithAssetsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<AssetWithRelatedMetadataDto>}
     * @memberof UploadWithAssetsDto
     */
    'assets': Array<AssetWithRelatedMetadataDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UploadWithAssetsDto
     */
    'newComments'?: boolean;
}

export const UploadWithAssetsDtoTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Document: 'DOCUMENT',
    Delivery: 'DELIVERY'
} as const;

export type UploadWithAssetsDtoTypeEnum = typeof UploadWithAssetsDtoTypeEnum[keyof typeof UploadWithAssetsDtoTypeEnum];
export const UploadWithAssetsDtoStateEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AdminFeedback: 'ADMIN_FEEDBACK',
    UserResponse: 'USER_RESPONSE',
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type UploadWithAssetsDtoStateEnum = typeof UploadWithAssetsDtoStateEnum[keyof typeof UploadWithAssetsDtoStateEnum];

/**
 * 
 * @export
 * @interface UploadWithSlimAssetsDto
 */
export interface UploadWithSlimAssetsDto {
    /**
     * 
     * @type {number}
     * @memberof UploadWithSlimAssetsDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UploadWithSlimAssetsDto
     */
    'type': UploadWithSlimAssetsDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadWithSlimAssetsDto
     */
    'allOriginalConfirmation': boolean | null;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadWithSlimAssetsDto
     */
    'user': UserDto;
    /**
     * 
     * @type {UserDto}
     * @memberof UploadWithSlimAssetsDto
     */
    'assignee'?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof UploadWithSlimAssetsDto
     */
    'state': UploadWithSlimAssetsDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadWithSlimAssetsDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<AssetDto>}
     * @memberof UploadWithSlimAssetsDto
     */
    'assets': Array<AssetDto>;
}

export const UploadWithSlimAssetsDtoTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Document: 'DOCUMENT',
    Delivery: 'DELIVERY'
} as const;

export type UploadWithSlimAssetsDtoTypeEnum = typeof UploadWithSlimAssetsDtoTypeEnum[keyof typeof UploadWithSlimAssetsDtoTypeEnum];
export const UploadWithSlimAssetsDtoStateEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AdminFeedback: 'ADMIN_FEEDBACK',
    UserResponse: 'USER_RESPONSE',
    Done: 'DONE',
    Denied: 'DENIED',
    PartialApproved: 'PARTIAL_APPROVED'
} as const;

export type UploadWithSlimAssetsDtoStateEnum = typeof UploadWithSlimAssetsDtoStateEnum[keyof typeof UploadWithSlimAssetsDtoStateEnum];

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'username': string;
    /**
     * 
     * @type {PreferenceDto}
     * @memberof UserDto
     */
    'preference'?: PreferenceDto;
}
/**
 * 
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    'isAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    'isIngkaUser': boolean;
}
/**
 * 
 * @export
 * @interface VerifyFilesExistDto
 */
export interface VerifyFilesExistDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyFilesExistDto
     */
    'fileUniqueIds': Array<string>;
}
/**
 * 
 * @export
 * @interface VerifyFilesExistResponseDto
 */
export interface VerifyFilesExistResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyFilesExistResponseDto
     */
    'results': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyFilesExistResponseDto
     */
    'allExist': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyFilesExistResponseDto
     */
    'missingFileIds': Array<string>;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssetsControllerCreateRequest} assetsControllerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreate: async (assetsControllerCreateRequest: AssetsControllerCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetsControllerCreateRequest' is not null or undefined
            assertParamExists('assetsControllerCreate', 'assetsControllerCreateRequest', assetsControllerCreateRequest)
            const localVarPath = `/api/v1/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsControllerCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateThumbnails: async (uploadId: number, files: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('assetsControllerCreateThumbnails', 'uploadId', uploadId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('assetsControllerCreateThumbnails', 'files', files)
            const localVarPath = `/api/v1/assets/thumbnails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (uploadId !== undefined) { 
                localVarFormParams.append('uploadId', uploadId as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindOne: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetsControllerFindOne', 'id', id)
            const localVarPath = `/api/v1/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindSimilarFiles: async (files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/assets/search/similarity-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssetsControllerGenerateUploadUrlsRequest} assetsControllerGenerateUploadUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGenerateUploadUrls: async (assetsControllerGenerateUploadUrlsRequest: AssetsControllerGenerateUploadUrlsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetsControllerGenerateUploadUrlsRequest' is not null or undefined
            assertParamExists('assetsControllerGenerateUploadUrls', 'assetsControllerGenerateUploadUrlsRequest', assetsControllerGenerateUploadUrlsRequest)
            const localVarPath = `/api/v1/assets/generate-upload-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetsControllerGenerateUploadUrlsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assetId 
         * @param {boolean} th 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGetFile: async (assetId: number, th: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetsControllerGetFile', 'assetId', assetId)
            // verify required parameter 'th' is not null or undefined
            assertParamExists('assetsControllerGetFile', 'th', th)
            const localVarPath = `/api/v1/assets/{assetId}/file`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (th !== undefined) {
                localVarQueryParameter['th'] = th;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerRemove: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetsControllerRemove', 'id', id)
            const localVarPath = `/api/v1/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assetId 
         * @param {string} relatedAssetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerRemoveRelatedAsset: async (assetId: number, relatedAssetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetsControllerRemoveRelatedAsset', 'assetId', assetId)
            // verify required parameter 'relatedAssetId' is not null or undefined
            assertParamExists('assetsControllerRemoveRelatedAsset', 'relatedAssetId', relatedAssetId)
            const localVarPath = `/api/v1/assets/{assetId}/related-asset/{relatedAssetId}`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)))
                .replace(`{${"relatedAssetId"}}`, encodeURIComponent(String(relatedAssetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateAssetDto} updateAssetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdate: async (id: number, updateAssetDto: UpdateAssetDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assetsControllerUpdate', 'id', id)
            // verify required parameter 'updateAssetDto' is not null or undefined
            assertParamExists('assetsControllerUpdate', 'updateAssetDto', updateAssetDto)
            const localVarPath = `/api/v1/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assetId 
         * @param {UpdateDocumentMetadataDto} updateDocumentMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdateDocumentMetadata: async (assetId: number, updateDocumentMetadataDto: UpdateDocumentMetadataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetsControllerUpdateDocumentMetadata', 'assetId', assetId)
            // verify required parameter 'updateDocumentMetadataDto' is not null or undefined
            assertParamExists('assetsControllerUpdateDocumentMetadata', 'updateDocumentMetadataDto', updateDocumentMetadataDto)
            const localVarPath = `/api/v1/assets/{assetId}/document-metadata`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentMetadataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assetId 
         * @param {UpdateRelatedAssetMetadataDto} updateRelatedAssetMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdateRelatedAssetMetadata: async (assetId: number, updateRelatedAssetMetadataDto: UpdateRelatedAssetMetadataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetsControllerUpdateRelatedAssetMetadata', 'assetId', assetId)
            // verify required parameter 'updateRelatedAssetMetadataDto' is not null or undefined
            assertParamExists('assetsControllerUpdateRelatedAssetMetadata', 'updateRelatedAssetMetadataDto', updateRelatedAssetMetadataDto)
            const localVarPath = `/api/v1/assets/{assetId}/related-asset/metadata`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRelatedAssetMetadataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} assetId 
         * @param {File} file 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUploadRelatedAsset: async (assetId: number, file: File, locale: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetsControllerUploadRelatedAsset', 'assetId', assetId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('assetsControllerUploadRelatedAsset', 'file', file)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('assetsControllerUploadRelatedAsset', 'locale', locale)
            const localVarPath = `/api/v1/assets/{assetId}/related-asset`
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (locale !== undefined) { 
                localVarFormParams.append('locale', locale as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyFilesExistDto} verifyFilesExistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerVerifyFilesExist: async (verifyFilesExistDto: VerifyFilesExistDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyFilesExistDto' is not null or undefined
            assertParamExists('assetsControllerVerifyFilesExist', 'verifyFilesExistDto', verifyFilesExistDto)
            const localVarPath = `/api/v1/assets/verify-files-exist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyFilesExistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCommentDto} createCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreate: async (createCommentDto: CreateCommentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCommentDto' is not null or undefined
            assertParamExists('commentsControllerCreate', 'createCommentDto', createCommentDto)
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentsByUploadId: async (uploadId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('commentsControllerGetCommentsByUploadId', 'uploadId', uploadId)
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uploadId !== undefined) {
                localVarQueryParameter['uploadId'] = uploadId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {number} maxCommId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateCommentAsSeen: async (uploadId: number, maxCommId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('commentsControllerUpdateCommentAsSeen', 'uploadId', uploadId)
            // verify required parameter 'maxCommId' is not null or undefined
            assertParamExists('commentsControllerUpdateCommentAsSeen', 'maxCommId', maxCommId)
            const localVarPath = `/api/v1/comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uploadId !== undefined) {
                localVarQueryParameter['uploadId'] = uploadId;
            }

            if (maxCommId !== undefined) {
                localVarQueryParameter['maxCommId'] = maxCommId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateFeedbackDto} createFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerCreate: async (createFeedbackDto: CreateFeedbackDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFeedbackDto' is not null or undefined
            assertParamExists('feedbackControllerCreate', 'createFeedbackDto', createFeedbackDto)
            const localVarPath = `/api/v1/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFeedbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataControllerGetMarketProducers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/metadata/market-producers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataControllerGetMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerFindUserNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerUpdateSeen: async (uploadId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('notificationsControllerUpdateSeen', 'uploadId', uploadId)
            const localVarPath = `/api/v1/notifications/{uploadId}/seen`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePreferenceDto} createPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferenceControllerCreateOrUpdate: async (createPreferenceDto: CreatePreferenceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPreferenceDto' is not null or undefined
            assertParamExists('preferenceControllerCreateOrUpdate', 'createPreferenceDto', createPreferenceDto)
            const localVarPath = `/api/v1/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPreferenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferenceControllerFindOne: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUploadDto} createUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerCreate: async (createUploadDto: CreateUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUploadDto' is not null or undefined
            assertParamExists('uploadsControllerCreate', 'createUploadDto', createUploadDto)
            const localVarPath = `/api/v1/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerFindOne: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadsControllerFindOne', 'id', id)
            const localVarPath = `/api/v1/uploads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerRemove: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadsControllerRemove', 'id', id)
            const localVarPath = `/api/v1/uploads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUploadDto} updateUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerUpdate: async (id: number, updateUploadDto: UpdateUploadDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadsControllerUpdate', 'id', id)
            // verify required parameter 'updateUploadDto' is not null or undefined
            assertParamExists('uploadsControllerUpdate', 'updateUploadDto', updateUploadDto)
            const localVarPath = `/api/v1/uploads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUploadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateDocumentUpload: async (uploadId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('uploadsControllerValidateDocumentUpload', 'uploadId', uploadId)
            const localVarPath = `/api/v1/uploads/{uploadId}/validate-document-data`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateMotionMediaUpload: async (uploadId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('uploadsControllerValidateMotionMediaUpload', 'uploadId', uploadId)
            const localVarPath = `/api/v1/uploads/{uploadId}/validate-motion-media-data`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateUploadAssets: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadsControllerValidateUploadAssets', 'id', id)
            const localVarPath = `/api/v1/uploads/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAdminUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetAdminUser', 'id', id)
            const localVarPath = `/api/v1/users/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} ignoreCache 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAdminUsers: async (ignoreCache: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ignoreCache' is not null or undefined
            assertParamExists('userControllerGetAdminUsers', 'ignoreCache', ignoreCache)
            const localVarPath = `/api/v1/users/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ignoreCache !== undefined) {
                localVarQueryParameter['ignoreCache'] = ignoreCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerInvalidateCache: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userControllerInvalidateCache', 'body', body)
            const localVarPath = `/api/v1/users/invalidate-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssetsControllerCreateRequest} assetsControllerCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerCreate(assetsControllerCreateRequest: AssetsControllerCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreate(assetsControllerCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerCreateThumbnails(uploadId: number, files: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreateThumbnails(uploadId, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerCreateThumbnails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindOne(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerFindSimilarFiles(files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimilaritySearchResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindSimilarFiles(files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerFindSimilarFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AssetsControllerGenerateUploadUrlsRequest} assetsControllerGenerateUploadUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerGenerateUploadUrls(assetsControllerGenerateUploadUrlsRequest: AssetsControllerGenerateUploadUrlsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StartFileuploadResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerGenerateUploadUrls(assetsControllerGenerateUploadUrlsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerGenerateUploadUrls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} assetId 
         * @param {boolean} th 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerGetFile(assetId: number, th: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerGetFile(assetId, th, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerGetFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerRemove(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} assetId 
         * @param {string} relatedAssetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerRemoveRelatedAsset(assetId: number, relatedAssetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerRemoveRelatedAsset(assetId, relatedAssetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerRemoveRelatedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateAssetDto} updateAssetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerUpdate(id: number, updateAssetDto: UpdateAssetDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdate(id, updateAssetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} assetId 
         * @param {UpdateDocumentMetadataDto} updateDocumentMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerUpdateDocumentMetadata(assetId: number, updateDocumentMetadataDto: UpdateDocumentMetadataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdateDocumentMetadata(assetId, updateDocumentMetadataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerUpdateDocumentMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} assetId 
         * @param {UpdateRelatedAssetMetadataDto} updateRelatedAssetMetadataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerUpdateRelatedAssetMetadata(assetId: number, updateRelatedAssetMetadataDto: UpdateRelatedAssetMetadataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedAssetMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdateRelatedAssetMetadata(assetId, updateRelatedAssetMetadataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerUpdateRelatedAssetMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} assetId 
         * @param {File} file 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerUploadRelatedAsset(assetId: number, file: File, locale: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedAssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUploadRelatedAsset(assetId, file, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerUploadRelatedAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyFilesExistDto} verifyFilesExistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsControllerVerifyFilesExist(verifyFilesExistDto: VerifyFilesExistDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyFilesExistResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerVerifyFilesExist(verifyFilesExistDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assetsControllerVerifyFilesExist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCommentDto} createCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerCreate(createCommentDto: CreateCommentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerCreate(createCommentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.commentsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerGetCommentsByUploadId(uploadId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerGetCommentsByUploadId(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.commentsControllerGetCommentsByUploadId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {number} maxCommId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsControllerUpdateCommentAsSeen(uploadId: number, maxCommId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsControllerUpdateCommentAsSeen(uploadId, maxCommId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.commentsControllerUpdateCommentAsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateFeedbackDto} createFeedbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackControllerCreate(createFeedbackDto: CreateFeedbackDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFeedbackDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackControllerCreate(createFeedbackDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.feedbackControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataControllerGetMarketProducers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketProducerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataControllerGetMarketProducers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metadataControllerGetMarketProducers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataControllerGetMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataControllerGetMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metadataControllerGetMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerFindUserNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerFindUserNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notificationsControllerFindUserNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerUpdateSeen(uploadId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerUpdateSeen(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.notificationsControllerUpdateSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePreferenceDto} createPreferenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preferenceControllerCreateOrUpdate(createPreferenceDto: CreatePreferenceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preferenceControllerCreateOrUpdate(createPreferenceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.preferenceControllerCreateOrUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preferenceControllerFindOne(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferenceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preferenceControllerFindOne(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.preferenceControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUploadDto} createUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerCreate(createUploadDto: CreateUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerCreate(createUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadWithSlimAssetsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerFindOne(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadWithAssetsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerFindOne(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerFindOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerRemove(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUploadDto} updateUploadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerUpdate(id: number, updateUploadDto: UpdateUploadDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerUpdate(id, updateUploadDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerValidateDocumentUpload(uploadId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerValidateDocumentUpload(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerValidateDocumentUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerValidateMotionMediaUpload(uploadId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerValidateMotionMediaUpload(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerValidateMotionMediaUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerValidateUploadAssets(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerValidateUploadAssets(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.uploadsControllerValidateUploadAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAdminUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAdminUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetAdminUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} ignoreCache 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAdminUsers(ignoreCache: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAdminUsers(ignoreCache, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetAdminUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerInvalidateCache(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerInvalidateCache(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerInvalidateCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {DefaultApiAssetsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreate(requestParameters: DefaultApiAssetsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetsControllerCreate(requestParameters.assetsControllerCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerCreateThumbnailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerCreateThumbnails(requestParameters: DefaultApiAssetsControllerCreateThumbnailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetsControllerCreateThumbnails(requestParameters.uploadId, requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<AssetDto>> {
            return localVarFp.assetsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindOne(requestParameters: DefaultApiAssetsControllerFindOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.assetsControllerFindOne(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerFindSimilarFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerFindSimilarFiles(requestParameters: DefaultApiAssetsControllerFindSimilarFilesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SimilaritySearchResponseDto>> {
            return localVarFp.assetsControllerFindSimilarFiles(requestParameters.files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerGenerateUploadUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGenerateUploadUrls(requestParameters: DefaultApiAssetsControllerGenerateUploadUrlsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StartFileuploadResult>> {
            return localVarFp.assetsControllerGenerateUploadUrls(requestParameters.assetsControllerGenerateUploadUrlsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerGetFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerGetFile(requestParameters: DefaultApiAssetsControllerGetFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.assetsControllerGetFile(requestParameters.assetId, requestParameters.th, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerRemove(requestParameters: DefaultApiAssetsControllerRemoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.assetsControllerRemove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerRemoveRelatedAssetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerRemoveRelatedAsset(requestParameters: DefaultApiAssetsControllerRemoveRelatedAssetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedAssetDto> {
            return localVarFp.assetsControllerRemoveRelatedAsset(requestParameters.assetId, requestParameters.relatedAssetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdate(requestParameters: DefaultApiAssetsControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetDto> {
            return localVarFp.assetsControllerUpdate(requestParameters.id, requestParameters.updateAssetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerUpdateDocumentMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdateDocumentMetadata(requestParameters: DefaultApiAssetsControllerUpdateDocumentMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentMetadataDto> {
            return localVarFp.assetsControllerUpdateDocumentMetadata(requestParameters.assetId, requestParameters.updateDocumentMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUpdateRelatedAssetMetadata(requestParameters: DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedAssetMetadataDto> {
            return localVarFp.assetsControllerUpdateRelatedAssetMetadata(requestParameters.assetId, requestParameters.updateRelatedAssetMetadataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerUploadRelatedAssetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerUploadRelatedAsset(requestParameters: DefaultApiAssetsControllerUploadRelatedAssetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedAssetDto> {
            return localVarFp.assetsControllerUploadRelatedAsset(requestParameters.assetId, requestParameters.file, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiAssetsControllerVerifyFilesExistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsControllerVerifyFilesExist(requestParameters: DefaultApiAssetsControllerVerifyFilesExistRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyFilesExistResponseDto> {
            return localVarFp.assetsControllerVerifyFilesExist(requestParameters.verifyFilesExistDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCommentsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerCreate(requestParameters: DefaultApiCommentsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCommentDto> {
            return localVarFp.commentsControllerCreate(requestParameters.createCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCommentsControllerGetCommentsByUploadIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerGetCommentsByUploadId(requestParameters: DefaultApiCommentsControllerGetCommentsByUploadIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetCommentDto>> {
            return localVarFp.commentsControllerGetCommentsByUploadId(requestParameters.uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiCommentsControllerUpdateCommentAsSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsControllerUpdateCommentAsSeen(requestParameters: DefaultApiCommentsControllerUpdateCommentAsSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commentsControllerUpdateCommentAsSeen(requestParameters.uploadId, requestParameters.maxCommId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiFeedbackControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackControllerCreate(requestParameters: DefaultApiFeedbackControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFeedbackDto> {
            return localVarFp.feedbackControllerCreate(requestParameters.createFeedbackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataControllerGetMarketProducers(options?: RawAxiosRequestConfig): AxiosPromise<Array<MarketProducerDto>> {
            return localVarFp.metadataControllerGetMarketProducers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataControllerGetMetadata(options?: RawAxiosRequestConfig): AxiosPromise<MetadataResponseDto> {
            return localVarFp.metadataControllerGetMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerFindUserNotifications(options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponseDto> {
            return localVarFp.notificationsControllerFindUserNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiNotificationsControllerUpdateSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerUpdateSeen(requestParameters: DefaultApiNotificationsControllerUpdateSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsControllerUpdateSeen(requestParameters.uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPreferenceControllerCreateOrUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferenceControllerCreateOrUpdate(requestParameters: DefaultApiPreferenceControllerCreateOrUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreferenceDto> {
            return localVarFp.preferenceControllerCreateOrUpdate(requestParameters.createPreferenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferenceControllerFindOne(options?: RawAxiosRequestConfig): AxiosPromise<PreferenceDto> {
            return localVarFp.preferenceControllerFindOne(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerCreate(requestParameters: DefaultApiUploadsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadDto> {
            return localVarFp.uploadsControllerCreate(requestParameters.createUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<UploadWithSlimAssetsDto>> {
            return localVarFp.uploadsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerFindOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerFindOne(requestParameters: DefaultApiUploadsControllerFindOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadWithAssetsDto> {
            return localVarFp.uploadsControllerFindOne(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerRemove(requestParameters: DefaultApiUploadsControllerRemoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadDto> {
            return localVarFp.uploadsControllerRemove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerUpdate(requestParameters: DefaultApiUploadsControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadDto> {
            return localVarFp.uploadsControllerUpdate(requestParameters.id, requestParameters.updateUploadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerValidateDocumentUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateDocumentUpload(requestParameters: DefaultApiUploadsControllerValidateDocumentUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadsControllerValidateDocumentUpload(requestParameters.uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerValidateMotionMediaUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateMotionMediaUpload(requestParameters: DefaultApiUploadsControllerValidateMotionMediaUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadsControllerValidateMotionMediaUpload(requestParameters.uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUploadsControllerValidateUploadAssetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerValidateUploadAssets(requestParameters: DefaultApiUploadsControllerValidateUploadAssetsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadsControllerValidateUploadAssets(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUserControllerGetAdminUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAdminUser(requestParameters: DefaultApiUserControllerGetAdminUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDto> {
            return localVarFp.userControllerGetAdminUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUserControllerGetAdminUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAdminUsers(requestParameters: DefaultApiUserControllerGetAdminUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserDto>> {
            return localVarFp.userControllerGetAdminUsers(requestParameters.ignoreCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileDto> {
            return localVarFp.userControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiUserControllerInvalidateCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerInvalidateCache(requestParameters: DefaultApiUserControllerInvalidateCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerInvalidateCache(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assetsControllerCreate operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerCreateRequest
 */
export interface DefaultApiAssetsControllerCreateRequest {
    /**
     * 
     * @type {AssetsControllerCreateRequest}
     * @memberof DefaultApiAssetsControllerCreate
     */
    readonly assetsControllerCreateRequest: AssetsControllerCreateRequest
}

/**
 * Request parameters for assetsControllerCreateThumbnails operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerCreateThumbnailsRequest
 */
export interface DefaultApiAssetsControllerCreateThumbnailsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerCreateThumbnails
     */
    readonly uploadId: number

    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiAssetsControllerCreateThumbnails
     */
    readonly files: Array<File>
}

/**
 * Request parameters for assetsControllerFindOne operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerFindOneRequest
 */
export interface DefaultApiAssetsControllerFindOneRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerFindOne
     */
    readonly id: number
}

/**
 * Request parameters for assetsControllerFindSimilarFiles operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerFindSimilarFilesRequest
 */
export interface DefaultApiAssetsControllerFindSimilarFilesRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiAssetsControllerFindSimilarFiles
     */
    readonly files?: Array<File>
}

/**
 * Request parameters for assetsControllerGenerateUploadUrls operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerGenerateUploadUrlsRequest
 */
export interface DefaultApiAssetsControllerGenerateUploadUrlsRequest {
    /**
     * 
     * @type {AssetsControllerGenerateUploadUrlsRequest}
     * @memberof DefaultApiAssetsControllerGenerateUploadUrls
     */
    readonly assetsControllerGenerateUploadUrlsRequest: AssetsControllerGenerateUploadUrlsRequest
}

/**
 * Request parameters for assetsControllerGetFile operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerGetFileRequest
 */
export interface DefaultApiAssetsControllerGetFileRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerGetFile
     */
    readonly assetId: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiAssetsControllerGetFile
     */
    readonly th: boolean
}

/**
 * Request parameters for assetsControllerRemove operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerRemoveRequest
 */
export interface DefaultApiAssetsControllerRemoveRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerRemove
     */
    readonly id: number
}

/**
 * Request parameters for assetsControllerRemoveRelatedAsset operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerRemoveRelatedAssetRequest
 */
export interface DefaultApiAssetsControllerRemoveRelatedAssetRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerRemoveRelatedAsset
     */
    readonly assetId: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAssetsControllerRemoveRelatedAsset
     */
    readonly relatedAssetId: string
}

/**
 * Request parameters for assetsControllerUpdate operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerUpdateRequest
 */
export interface DefaultApiAssetsControllerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UpdateAssetDto}
     * @memberof DefaultApiAssetsControllerUpdate
     */
    readonly updateAssetDto: UpdateAssetDto
}

/**
 * Request parameters for assetsControllerUpdateDocumentMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerUpdateDocumentMetadataRequest
 */
export interface DefaultApiAssetsControllerUpdateDocumentMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerUpdateDocumentMetadata
     */
    readonly assetId: number

    /**
     * 
     * @type {UpdateDocumentMetadataDto}
     * @memberof DefaultApiAssetsControllerUpdateDocumentMetadata
     */
    readonly updateDocumentMetadataDto: UpdateDocumentMetadataDto
}

/**
 * Request parameters for assetsControllerUpdateRelatedAssetMetadata operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest
 */
export interface DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerUpdateRelatedAssetMetadata
     */
    readonly assetId: number

    /**
     * 
     * @type {UpdateRelatedAssetMetadataDto}
     * @memberof DefaultApiAssetsControllerUpdateRelatedAssetMetadata
     */
    readonly updateRelatedAssetMetadataDto: UpdateRelatedAssetMetadataDto
}

/**
 * Request parameters for assetsControllerUploadRelatedAsset operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerUploadRelatedAssetRequest
 */
export interface DefaultApiAssetsControllerUploadRelatedAssetRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiAssetsControllerUploadRelatedAsset
     */
    readonly assetId: number

    /**
     * 
     * @type {File}
     * @memberof DefaultApiAssetsControllerUploadRelatedAsset
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAssetsControllerUploadRelatedAsset
     */
    readonly locale: string
}

/**
 * Request parameters for assetsControllerVerifyFilesExist operation in DefaultApi.
 * @export
 * @interface DefaultApiAssetsControllerVerifyFilesExistRequest
 */
export interface DefaultApiAssetsControllerVerifyFilesExistRequest {
    /**
     * 
     * @type {VerifyFilesExistDto}
     * @memberof DefaultApiAssetsControllerVerifyFilesExist
     */
    readonly verifyFilesExistDto: VerifyFilesExistDto
}

/**
 * Request parameters for commentsControllerCreate operation in DefaultApi.
 * @export
 * @interface DefaultApiCommentsControllerCreateRequest
 */
export interface DefaultApiCommentsControllerCreateRequest {
    /**
     * 
     * @type {CreateCommentDto}
     * @memberof DefaultApiCommentsControllerCreate
     */
    readonly createCommentDto: CreateCommentDto
}

/**
 * Request parameters for commentsControllerGetCommentsByUploadId operation in DefaultApi.
 * @export
 * @interface DefaultApiCommentsControllerGetCommentsByUploadIdRequest
 */
export interface DefaultApiCommentsControllerGetCommentsByUploadIdRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiCommentsControllerGetCommentsByUploadId
     */
    readonly uploadId: number
}

/**
 * Request parameters for commentsControllerUpdateCommentAsSeen operation in DefaultApi.
 * @export
 * @interface DefaultApiCommentsControllerUpdateCommentAsSeenRequest
 */
export interface DefaultApiCommentsControllerUpdateCommentAsSeenRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiCommentsControllerUpdateCommentAsSeen
     */
    readonly uploadId: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiCommentsControllerUpdateCommentAsSeen
     */
    readonly maxCommId: number
}

/**
 * Request parameters for feedbackControllerCreate operation in DefaultApi.
 * @export
 * @interface DefaultApiFeedbackControllerCreateRequest
 */
export interface DefaultApiFeedbackControllerCreateRequest {
    /**
     * 
     * @type {CreateFeedbackDto}
     * @memberof DefaultApiFeedbackControllerCreate
     */
    readonly createFeedbackDto: CreateFeedbackDto
}

/**
 * Request parameters for notificationsControllerUpdateSeen operation in DefaultApi.
 * @export
 * @interface DefaultApiNotificationsControllerUpdateSeenRequest
 */
export interface DefaultApiNotificationsControllerUpdateSeenRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiNotificationsControllerUpdateSeen
     */
    readonly uploadId: number
}

/**
 * Request parameters for preferenceControllerCreateOrUpdate operation in DefaultApi.
 * @export
 * @interface DefaultApiPreferenceControllerCreateOrUpdateRequest
 */
export interface DefaultApiPreferenceControllerCreateOrUpdateRequest {
    /**
     * 
     * @type {CreatePreferenceDto}
     * @memberof DefaultApiPreferenceControllerCreateOrUpdate
     */
    readonly createPreferenceDto: CreatePreferenceDto
}

/**
 * Request parameters for uploadsControllerCreate operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerCreateRequest
 */
export interface DefaultApiUploadsControllerCreateRequest {
    /**
     * 
     * @type {CreateUploadDto}
     * @memberof DefaultApiUploadsControllerCreate
     */
    readonly createUploadDto: CreateUploadDto
}

/**
 * Request parameters for uploadsControllerFindOne operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerFindOneRequest
 */
export interface DefaultApiUploadsControllerFindOneRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerFindOne
     */
    readonly id: number
}

/**
 * Request parameters for uploadsControllerRemove operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerRemoveRequest
 */
export interface DefaultApiUploadsControllerRemoveRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerRemove
     */
    readonly id: number
}

/**
 * Request parameters for uploadsControllerUpdate operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerUpdateRequest
 */
export interface DefaultApiUploadsControllerUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerUpdate
     */
    readonly id: number

    /**
     * 
     * @type {UpdateUploadDto}
     * @memberof DefaultApiUploadsControllerUpdate
     */
    readonly updateUploadDto: UpdateUploadDto
}

/**
 * Request parameters for uploadsControllerValidateDocumentUpload operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerValidateDocumentUploadRequest
 */
export interface DefaultApiUploadsControllerValidateDocumentUploadRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerValidateDocumentUpload
     */
    readonly uploadId: number
}

/**
 * Request parameters for uploadsControllerValidateMotionMediaUpload operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerValidateMotionMediaUploadRequest
 */
export interface DefaultApiUploadsControllerValidateMotionMediaUploadRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerValidateMotionMediaUpload
     */
    readonly uploadId: number
}

/**
 * Request parameters for uploadsControllerValidateUploadAssets operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadsControllerValidateUploadAssetsRequest
 */
export interface DefaultApiUploadsControllerValidateUploadAssetsRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadsControllerValidateUploadAssets
     */
    readonly id: number
}

/**
 * Request parameters for userControllerGetAdminUser operation in DefaultApi.
 * @export
 * @interface DefaultApiUserControllerGetAdminUserRequest
 */
export interface DefaultApiUserControllerGetAdminUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUserControllerGetAdminUser
     */
    readonly id: string
}

/**
 * Request parameters for userControllerGetAdminUsers operation in DefaultApi.
 * @export
 * @interface DefaultApiUserControllerGetAdminUsersRequest
 */
export interface DefaultApiUserControllerGetAdminUsersRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUserControllerGetAdminUsers
     */
    readonly ignoreCache: boolean
}

/**
 * Request parameters for userControllerInvalidateCache operation in DefaultApi.
 * @export
 * @interface DefaultApiUserControllerInvalidateCacheRequest
 */
export interface DefaultApiUserControllerInvalidateCacheRequest {
    /**
     * 
     * @type {object}
     * @memberof DefaultApiUserControllerInvalidateCache
     */
    readonly body: object
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {DefaultApiAssetsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerCreate(requestParameters: DefaultApiAssetsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerCreate(requestParameters.assetsControllerCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerCreateThumbnailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerCreateThumbnails(requestParameters: DefaultApiAssetsControllerCreateThumbnailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerCreateThumbnails(requestParameters.uploadId, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerFindAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerFindOne(requestParameters: DefaultApiAssetsControllerFindOneRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerFindOne(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerFindSimilarFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerFindSimilarFiles(requestParameters: DefaultApiAssetsControllerFindSimilarFilesRequest = {}, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerFindSimilarFiles(requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerGenerateUploadUrlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerGenerateUploadUrls(requestParameters: DefaultApiAssetsControllerGenerateUploadUrlsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerGenerateUploadUrls(requestParameters.assetsControllerGenerateUploadUrlsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerGetFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerGetFile(requestParameters: DefaultApiAssetsControllerGetFileRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerGetFile(requestParameters.assetId, requestParameters.th, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerRemove(requestParameters: DefaultApiAssetsControllerRemoveRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerRemove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerRemoveRelatedAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerRemoveRelatedAsset(requestParameters: DefaultApiAssetsControllerRemoveRelatedAssetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerRemoveRelatedAsset(requestParameters.assetId, requestParameters.relatedAssetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerUpdate(requestParameters: DefaultApiAssetsControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerUpdate(requestParameters.id, requestParameters.updateAssetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerUpdateDocumentMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerUpdateDocumentMetadata(requestParameters: DefaultApiAssetsControllerUpdateDocumentMetadataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerUpdateDocumentMetadata(requestParameters.assetId, requestParameters.updateDocumentMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerUpdateRelatedAssetMetadata(requestParameters: DefaultApiAssetsControllerUpdateRelatedAssetMetadataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerUpdateRelatedAssetMetadata(requestParameters.assetId, requestParameters.updateRelatedAssetMetadataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerUploadRelatedAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerUploadRelatedAsset(requestParameters: DefaultApiAssetsControllerUploadRelatedAssetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerUploadRelatedAsset(requestParameters.assetId, requestParameters.file, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiAssetsControllerVerifyFilesExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assetsControllerVerifyFilesExist(requestParameters: DefaultApiAssetsControllerVerifyFilesExistRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assetsControllerVerifyFilesExist(requestParameters.verifyFilesExistDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCommentsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public commentsControllerCreate(requestParameters: DefaultApiCommentsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).commentsControllerCreate(requestParameters.createCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCommentsControllerGetCommentsByUploadIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public commentsControllerGetCommentsByUploadId(requestParameters: DefaultApiCommentsControllerGetCommentsByUploadIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).commentsControllerGetCommentsByUploadId(requestParameters.uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiCommentsControllerUpdateCommentAsSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public commentsControllerUpdateCommentAsSeen(requestParameters: DefaultApiCommentsControllerUpdateCommentAsSeenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).commentsControllerUpdateCommentAsSeen(requestParameters.uploadId, requestParameters.maxCommId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiFeedbackControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public feedbackControllerCreate(requestParameters: DefaultApiFeedbackControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).feedbackControllerCreate(requestParameters.createFeedbackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public metadataControllerGetMarketProducers(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metadataControllerGetMarketProducers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public metadataControllerGetMetadata(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metadataControllerGetMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public notificationsControllerFindUserNotifications(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notificationsControllerFindUserNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiNotificationsControllerUpdateSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public notificationsControllerUpdateSeen(requestParameters: DefaultApiNotificationsControllerUpdateSeenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).notificationsControllerUpdateSeen(requestParameters.uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPreferenceControllerCreateOrUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public preferenceControllerCreateOrUpdate(requestParameters: DefaultApiPreferenceControllerCreateOrUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).preferenceControllerCreateOrUpdate(requestParameters.createPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public preferenceControllerFindOne(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).preferenceControllerFindOne(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerCreate(requestParameters: DefaultApiUploadsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerCreate(requestParameters.createUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerFindAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerFindOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerFindOne(requestParameters: DefaultApiUploadsControllerFindOneRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerFindOne(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerRemove(requestParameters: DefaultApiUploadsControllerRemoveRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerRemove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerUpdate(requestParameters: DefaultApiUploadsControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerUpdate(requestParameters.id, requestParameters.updateUploadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerValidateDocumentUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerValidateDocumentUpload(requestParameters: DefaultApiUploadsControllerValidateDocumentUploadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerValidateDocumentUpload(requestParameters.uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerValidateMotionMediaUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerValidateMotionMediaUpload(requestParameters: DefaultApiUploadsControllerValidateMotionMediaUploadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerValidateMotionMediaUpload(requestParameters.uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUploadsControllerValidateUploadAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadsControllerValidateUploadAssets(requestParameters: DefaultApiUploadsControllerValidateUploadAssetsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadsControllerValidateUploadAssets(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUserControllerGetAdminUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userControllerGetAdminUser(requestParameters: DefaultApiUserControllerGetAdminUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetAdminUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUserControllerGetAdminUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userControllerGetAdminUsers(requestParameters: DefaultApiUserControllerGetAdminUsersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetAdminUsers(requestParameters.ignoreCache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userControllerGetMe(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiUserControllerInvalidateCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public userControllerInvalidateCache(requestParameters: DefaultApiUserControllerInvalidateCacheRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerInvalidateCache(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



